import { Flame } from "lucide-react";

export const InfoWelcome = () => {
  return (
    <div className="flex flex-col gap-2">
      <header className="flex items-center gap-1">
        <Flame aria-hidden="true" className="pt-0.5" size={18} />
        <h2 className="text-xl font-semibold">Welcome</h2>
      </header>
      <section>
        <p className="text-default-600 ml-3">
          Welcome to canvas! This is an event that lasts for 48 hours where
          users can place pixels every so often on a shared canvas. Everyone has
          access to the same canvas and pixels can be placed in any location to
          create things on the canvas.
        </p>
      </section>
    </div>
  );
};
